import CopyButton from '@/src/components/AppComponents/CopyButton/CopyButton';
import OpenInNewTabButton from '@/src/components/AppComponents/OpenInNewTabButton/OpenInNewTabButton';
import LoaderButton from '@/src/components/Commons/LoaderButton/LoaderButton';
import { formatAmountWithUnit, formatCurrencySymbol } from '@/src/lib/SmartDB/Commons/formatters';
import { UTxO } from '@lucid-evolution/lucid';
import styles from './DetailsBalance.module.scss';
import { useDetailsBalance } from './useDetailsBalance';

export const DetailsBalance = ({ uTxOs }: { uTxOs: UTxO[] }) => {
    //--------------------------------------
    const { appStore, isRefreshing, isLoadingDetails, isLoadedDetails, current, refreshDetails } = useDetailsBalance({ uTxOs });
    //--------------------------------------
    return isLoadingDetails ? (
        <div className={styles.loadingDiv}>{<LoaderButton />}</div>
    ) : (
        <>
            {isLoadedDetails === true && current !== undefined ? (
                <>
                    <table className={styles.tableModal}>
                        <thead>
                            <tr>
                                <th>Currency Symbol</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {current.map((key, index) => (
                                <tr key={index}>
                                    <td>
                                        <div className={styles.itemWidthIcons}>
                                            {formatCurrencySymbol(key.CS)}
                                            <CopyButton content={key.CS} />
                                            <OpenInNewTabButton
                                                url={appStore.siteSettings !== undefined ? `${appStore.siteSettings.getblockfrost_url_explorer_policy(key.CS)}` : ``}
                                            />
                                        </div>
                                    </td>
                                    <td>{formatAmountWithUnit(key.amount, key.ticker, 2, true, key.decimals)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </>
            ) : null}
        </>
    );
    //--------------------------------------
};
